import React from "react";
import styled from "styled-components";

const Box = styled.div`
  position: relative;
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
  width: 1218px;
  height: 810px;
  background: url(${require("@assets/img/cardgame/card_start_background.png")})
    no-repeat;
  margin: 0 auto;
`;
const Title = styled.div`
  position: absolute;
  left: 50%;
  top: 60px;
  transform: translateX(-50%);
  width: 668px;
  height: 242px;
  background: url(${require("@assets/img/cardgame/card_start_text.png")})
    no-repeat;
`;

const Help = styled.div`
  position: absolute;
  left: 50%;
  bottom: 90px;
  transform: translateX(-50%);
  width: 1143px;
  height: 343px;
  background: url(${require("@assets/img/cardgame/card_start_help.png")})
    no-repeat;
`;

const StartButton = styled.button`
  position: absolute;
  width: 335px;
  height: 128px;
  background: url(${require("@assets/img/cardgame/card_start_btn.png")})
    no-repeat;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
`;

const CardGameStartPop = ({ onClick }) => {
  return (
    // <Wrap>
    <Box>
      <Title />
      <Help />
      <StartButton id="card_start" type="button" onClick={onClick} />
    </Box>
    // </Wrap>
  );
};

export default CardGameStartPop;
